import useIsFeatureFlagEnabled from './useIsFeatureFlagEnabled';

const useIsCdfEnabled = () => useIsFeatureFlagEnabled('cdfEnabled');

export default useIsCdfEnabled;
